var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fa-secondary{opacity:.4}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 256C294.695 256 352 198.691 352 128S294.695 0 224 0C153.312 0 96 57.309 96 128S153.312 256 224 256ZM320 368C320 348.699 323.221 330.176 328.961 312.797C311.867 307.16 293.646 304 274.664 304H173.336C77.609 304 0 381.602 0 477.332C0 496.477 15.523 512 34.664 512H395.002C349.691 480.156 320 427.586 320 368Z",
    className: "fa-secondary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 224.001C416.375 224.001 352 288.376 352 368.001S416.375 512.001 496 512.001S640 447.626 640 368.001S575.625 224.001 496 224.001ZM544 384.001H489.75C484.375 384.001 480 379.626 480 374.251V304.001C480 295.165 487.164 288.001 496 288.001C504.838 288.001 512 295.165 512 304.001V352.001H544C552.838 352.001 560 359.165 560 368.001S552.838 384.001 544 384.001Z",
    className: "fa-primary"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserClock);
export default __webpack_public_path__ + "static/media/user-clock.e4765817.svg";
export { ForwardRef as ReactComponent };